"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createSymbol = _interopRequireDefault(require("./createSymbol"));

var KEY = '$___storybook.symbolName';
var symbolType = {
  KEY: KEY,
  is: function is(value) {
    return (0, _typeof2.default)(value) === 'symbol';
  },
  serialize: function serialize(value) {
    return (0, _defineProperty2.default)({}, KEY, String(value).slice(7, -1) || null);
  },
  deserialize: function deserialize(value) {
    return (0, _createSymbol.default)(value[KEY]);
  }
};
var _default = symbolType;
exports.default = _default;